import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Typography } from '../../atoms/Typography';


export const StyledTableWrapper = styled('div')`
  overflow: auto;
  width: 100%;
  & .super-app-theme--notes {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--uploads {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--part-actions-and-logistics-events {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--tasks {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--sla-events {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--service-events {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--notification-events {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--assignment-events {
    background-color: ${COLORS.CardBackground};
  };
  & .super-app-theme--tbc-interactions-data {
    background-color: ${COLORS.CardBackground};
  };
`;

export const StyledTypography = styled(Typography)`
  color: #c0bfc0;
`;
